<template>
  <div class="home" :class="{ mobile: $vuetify.breakpoint.smAndDown }">
    <div class="text" :class="{ mobile: $vuetify.breakpoint.smAndDown }" :style="{
      transform,
      filter: 'blur(' + blur + 'px )',
      opacity: textOpacity
    }">
      <Logo :topProp="0" :leftProp="0" position="static" v-if="$vuetify.breakpoint.smAndDown"/>
      <div v-if="$vuetify.breakpoint.mdAndUp">
        <h1 class="first-line"><span :style="{top: topOne}">Full stack web</span></h1>
        <h1 class="second-line">
          <span
            :style="{
              top: topTwo,
              height
            }"
          >development</span>
        </h1>
      </div>
      <p :style="{opacity:paragraphOpacity, transform:paragraphTransform}">An Austin based agency that helps<br>you <span class="plan">plan</span>, <span class="build">build</span>, and <span class="grow">grow</span> your ideas<br>on the web.</p>
      <div :style="{opacity:buttonOpacity}">
        <router-link
          v-if="$vuetify.breakpoint.mdAndUp"
          to="Contact"
          class="contact"
          :class="{'clicked': mousedown}"
          v-on:mousedown="mousedown = true"
          v-on:mouseup="mousedown = false"
          href="#"
        >
          <button>Let's talk</button>
        </router-link>
        <router-link
          v-else
          to="Contact"
          class="contact-mobile"
          :class="{'clicked': mousedown}"
          v-on:mousedown="mousedown = true"
          v-on:mouseup="mousedown = false"
          href="#"
        >
          <v-btn
            rounded
            large
            block
          >
            Get started
          </v-btn>
        </router-link>
      </div>
      <!-- <button class="contact" style="margin-left: 40px;" :class="{'clicked': mousedown}" v-on:mousedown="mousedown = true" v-on:mouseup="mousedown = false" v-on:click="zoomOut" href="">Zoom Out</button>
      <button class="contact" style="margin-left: 40px;" :class="{'clicked': mousedown}" v-on:mousedown="mousedown = true" v-on:mouseup="mousedown = false" v-on:click="zoomIn" href="">Zoom In</button> -->
    </div>
    <!-- <div class="right">
      <img src="@/assets/temp.png" alt="" class="world">
    </div> -->
  </div>
</template>

<script>
// @ is an alias to /src
import Logo from '@/components/Logo.vue'
import pageLoadAnimationBus from '../pageLoadAnimationBus'
import homeOutAnimationBus from '../homeOutAnimationBus'

export default {
  name: 'Home',
  components: {
    Logo
  },
  data () {
    return {
      blur: 0,
      textOpacity: 1,
      mousedown: false,
      opacity: 0,
      paragraphOpacity: 1,
      buttonOpacity: 1,
      translateY: 0,
      topOneValue: 0,
      topTwoValue: 0,
      pTransform: 0
    }
  },
  computed: {
    transform () { return 'translateY(' + (this.translateY).toString() + 'px)' },
    topOne () { return this.topOneValue.toString() + 'px' },
    topTwo () { return this.topTwoValue.toString() + 'px' },
    height () { return (this.opacity * 20) + 80 },
    paragraphTransform () { return 'translateY(' + (this.pTransform).toString() + 'px)' }
  },
  mounted () {
    pageLoadAnimationBus.registerComponent('home', this)
    homeOutAnimationBus.registerComponent('home', this)
    setTimeout(() => {
      this.animateBouncyText()
    }, 5000)
  },
  beforeRouteLeave (to, from, next) {
    homeOutAnimationBus.masterAnimate({ mobile: this.$vuetify.breakpoint.smAndDown }).then(() => { next() })
  },
  methods: {
    animateBouncyText () {
      var tl = this.$gsap.timeline({ repeat: -1, repeatDelay: 5 })
      tl.to('.plan', { y: -10, duration: 0.3, ease: 'power1.out' })
      tl.to('.plan', { y: 0, duration: 0.5, ease: 'bounce.out' })
      tl.to('.build', { y: -10, duration: 0.3, ease: 'power1.out' }, '-=0.3')
      tl.to('.build', { y: 0, duration: 0.5, ease: 'bounce.out' })
      tl.to('.grow', { y: -10, duration: 0.3, ease: 'power1.out' }, '-=0.3')
      tl.to('.grow', { y: 0, duration: 0.5, ease: 'bounce.out' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .home{
    display: flex;
    align-items: center;
    height: 100vh; /* Fallback for browsers that do not support Custom Properties */
    height: calc(var(--vh, 1vh) * 100);
    // grid-template-columns: 6fr 4fr;
    // gap: 5vw;
    position: absolute;
    top: 0;
    &.mobile{
      align-items: flex-end;
      p{
        font-size: 1em;
        margin: 20px 0 40px 0;
      }
    }
    .text{
      margin: 5vw;
      cursor: default;
      overflow: initial;
      &.mobile{
        text-align: center;
        margin: 0;
        width: 100vw;
        display: grid;
        place-items: center;
        margin-bottom: calc(15vh - 50px);
      }
    }
    >div{
      img{
        width: 100%;
      }
    }
    h1{
      font-family: Poppins;
      text-transform: capitalize;
      font-style: normal;
      font-weight: 500;
      font-size: calc(5.5vw);
      line-height: 7vw;
      overflow: hidden;
      // position: absolute;
      height: 7vw;
      span{
        position: relative;
        top: 0px;
        overflow: hidden;
        display: block;
      }
    }
    p{
      font-size: 1.6vw;
      margin: 20px 0;
      span{
        display: inline-block;
      }
    }
    .contact-mobile{
      text-decoration: none;
      width: 80vw;
    }
    .contact button{
      background-color: rgba($color: #FFFFFF, $alpha: 0.0);
      border: 1px solid white;
      border-radius: 5px;
      color: white;
      padding: 5px 35px 7px 35px;
      margin: 20px 0;
      font-size: 1.2vw;
      transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;
      // border: 1px solid rgba($color: #FFFFFF, $alpha: 1.0);
      &:hover{
        background-color: rgba($color: #FFFFFF, $alpha: 0.2);
        transform: scale(1.1);

        border: 1px solid rgba($color: #FFFFFF, $alpha: 0.8);
      }
      &.clicked:hover{
        background-color: rgba($color: #FFFFFF, $alpha: 1);
      }
    }
  }
</style>
